import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { I as InputFormGroup } from '../InputFormGroup/InputFormGroup-21JPbmEs.js';
import { S as SearchInputComponent } from './SearchInputComponent-CpCXmW6Z.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const NodeSafeInputElement = typeof HTMLInputElement !== 'undefined' ? HTMLInputElement : Object;
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-mrslaf-0"
})(["", " width:100%;position:relative;", ""], ({
  $fullWidth,
  theme
}) => !$fullWidth && `max-width: ${theme.form.input.maxWidth};`, isMobile(css(["max-width:", ";"], ({
  theme
}) => theme.form.input.mobile.maxWidth)));
Wrapper.displayName = 'Wrapper';
class SearchInput extends PureComponent {
  render() {
    const {
      taktId,
      taktValue
    } = this.props;
    const {
      id,
      disabled,
      value,
      inputRef,
      label,
      hideLabel,
      fullWidth,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(Wrapper, {
      $fullWidth: fullWidth
    }, /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('search-input')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(InputFormGroup, _extends({}, getDataTaktAttributes(), rest, {
      id: id,
      inputRef: inputRef,
      disabled: disabled,
      value: value,
      label: label,
      hideLabel: hideLabel,
      fullWidth: fullWidth,
      inputElement: SearchInputComponent,
      type: "search"
    }))));
  }
}
_defineProperty(SearchInput, "propTypes", {
  id: PT.string.isRequired,
  value: PT.string.isRequired,
  onClear: PT.func.isRequired,
  disabled: PT.bool,
  inputRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(NodeSafeInputElement)
  })]),
  label: PT.string,
  hideLabel: PT.bool,
  fullWidth: PT.bool,
  prefix: PT.node,
  suffix: PT.node,
  clearBtnProps: PT.objectOf(PT.any),
  clearButtonLabel: PT.string
});
_defineProperty(SearchInput, "defaultProps", {
  disabled: false,
  label: 'Search',
  hideLabel: true,
  fullWidth: false,
  inputRef: () => null,
  prefix: undefined,
  suffix: undefined,
  clearBtnProps: {},
  clearButtonLabel: 'Clear search terms'
});

export { SearchInput as S };
//# sourceMappingURL=SearchInput-BBGQZXLD.js.map
